import { IndustryConfig } from './industry-config.interface';
import { IndustryType } from './industry-types.enum';

/**
 * Pharmacy Industry Configuration
 * Uses the same retail UI and features (80% retail parity).
 * All API calls are routed via the /v1/pharmacy/ path segment.
 */
export const PharmacyIndustryConfig: IndustryConfig = {
    industryType: IndustryType.PHARMACY,
    name: 'Pharmacy',
    apiPathSegment: 'pharmacy', // API calls → /v1/pharmacy/...
    features: {
        enableFreeQuantity: false,
        enableMapping: false,
        enableVariants: false,
        enableTableManagement: false,
        enableKitchenDisplay: false,
        productSearchFields: [],
        orderPlacementFields: [],
    },
};
